import React, { useEffect } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import { useSelector } from 'react-redux';
import { ProtectedRoute } from './lib/router/routes';

import LoginPage from './modules/login';
import OktaPage from './modules/login/sso/okta';
import GraphQLEditor from './modules/graphiqlEditor';
import OidcPage from './modules/login/sso/oidc';

const App = () => {
  const currentEnv = useSelector(state => state.auth.currentEnv);

  useEffect(() => {
    if (currentEnv) {
      document.title = currentEnv;
    }
  });
  return <BrowserRouter>
    <Switch>
      <Route exact path='/login'>
        <LoginPage />
      </Route>
      <Route exact path='/sso/okta'>
        <OktaPage />
      </Route>
      <Route exact path='/sso/oidc'>
        <OidcPage />
      </Route>
      <ProtectedRoute path='/'>
        <GraphQLEditor />
      </ProtectedRoute>
    </Switch>
  </BrowserRouter>;
};

export default App;